export default "__VITE_ASSET__CCoK40Pl__"